import { IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { ChatMessageType } from '../../enums';

export class UpdateChatMessageDto {
	@IsUUID()
	id: string;

	@IsOptional()
	@IsEnum(ChatMessageType)
	type?: ChatMessageType;

	@IsOptional()
	@IsString()
	text?: string;

	@IsOptional()
	@IsString()
	image_id?: string;

	@IsOptional()
	@IsString()
	gif?: string;

	@IsOptional()
	@IsString()
	sticker?: string;
}
